import { render } from "./skeletonBlock.vue?vue&type=template&id=a69c720a"
const script = {}

import exportComponent from "E:\\Work\\Sales point\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__